import UserProfileService from "../../apiServices/user/userProfileService";
import keyCloackService from "../../helper/key-cloack-service";
import { alertConstants } from "../../helper/sweet-alert";
import { setUserProfileData } from "../../store/slices/user/userSlice";

export function getCurrentUserData(
) {
  return async function (dispatch: any, getState: any) {
    let response = await UserProfileService.getCurrentUserData();
    if (response?.success === true) {
      localStorage.setItem("username", response.data?.email || "");
      dispatch(setUserProfileData(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateUserProfile(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await UserProfileService.updateUserProfile(data);
    if (response?.success === true) {
      await keyCloackService.refreshToken();
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}
